function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 142 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7477.78,-287.191)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.55556,0,0,5.55556,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,1346,52.8889)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.306,
    width: 25.552,
    height: 1.5,
    style: {
      fill: "rgb(238,67,34)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,1346,59.9999)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.306,
    width: 25.552,
    height: 1.5,
    style: {
      fill: "rgb(238,67,34)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,1346,67.5559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.306,
    width: 25.552,
    height: 1.5,
    style: {
      fill: "rgb(238,67,34)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.d28ec8bc8627ee7f60f926023553acff.svg";
export { ForwardRef as ReactComponent };